import { createReducer } from 'redux-act';

import {
  SCENARIOS_FETCH_DATA_INIT,
  SCENARIOS_FETCH_DATA_SUCCESS,
  SCENARIOS_FETCH_DATA_FAIL,
  SCENARIOS_DELETE_SCENARIO_INIT,
  SCENARIOS_DELETE_SCENARIO_SUCCESS,
  SCENARIOS_DELETE_SCENARIO_FAIL,
  SCENARIOS_CLEAR_DATA,
  SCENARIOS_CREATE_SCENARIO_INIT,
  SCENARIOS_CREATE_SCENARIO_SUCCESS,
  SCENARIOS_CREATE_SCENARIO_FAIL,
  SCENARIOS_MODIFY_SCENARIO_INIT,
  SCENARIOS_MODIFY_SCENARIO_SUCCESS,
  SCENARIOS_MODIFY_SCENARIO_FAIL,
  SCENARIOS_CLEAN_UP,
  SCENARIOS_CLEAR_DATA_LOGOUT,
  SCENARIOS_SYNC_SCENARIO_INIT,
  SCENARIOS_SYNC_SCENARIO_SUCCESS,
  SCENARIOS_SYNC_SCENARIO_FAIL,
} from 'state/actions/scenario';

const initialState = {
  list: [],
  scenario: {},
  loading: false,
  downloading: false,
  updated: false,
  error: {
    errors: null,
    message: '',
  },
  success: false,
  deleted: false,
};

export const scenarioReducer = createReducer(
  {
    [SCENARIOS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [SCENARIOS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      scenario: payload.poi || initialState.scenario,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [SCENARIOS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCENARIOS_DELETE_SCENARIO_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCENARIOS_DELETE_SCENARIO_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      deleted: true,
    }),
    [SCENARIOS_DELETE_SCENARIO_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCENARIOS_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [SCENARIOS_CREATE_SCENARIO_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCENARIOS_CREATE_SCENARIO_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
      updated: true,
    }),
    [SCENARIOS_CREATE_SCENARIO_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCENARIOS_MODIFY_SCENARIO_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCENARIOS_MODIFY_SCENARIO_SUCCESS]: (state) => ({
      ...state,

      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
      updated: true,
    }),
    [SCENARIOS_MODIFY_SCENARIO_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCENARIOS_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: false,
      deleted: false,
      updated: false,
    }),
    [SCENARIOS_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SCENARIOS_SYNC_SCENARIO_INIT]: (state) => ({
      ...state,
      downloading: true,
    }),
    [SCENARIOS_SYNC_SCENARIO_SUCCESS]: (state) => ({
      ...state,
      downloading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [SCENARIOS_SYNC_SCENARIO_FAIL]: (state, payload) => ({
      ...state,
      downloading: false,
      error: payload.error,
    }),
  },
  initialState
);
